












































































































































































































































































































































































































































































































































































































































































































export default {
    name: 'IconSet',
};
